import { render } from "./Cessazione.vue?vue&type=template&id=0bac46da&scoped=true"
import script from "./Cessazione.vue?vue&type=script&lang=js"
export * from "./Cessazione.vue?vue&type=script&lang=js"

import "./Cessazione.vue?vue&type=style&index=0&id=0bac46da&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bac46da"]])

export default __exports__